import React from "react";
import { LimitsApplyAccordion, SuppressionHandler } from "../../../components";
import { Plan } from "../../../@types";
import {
  getBenefitCost,
  getBenefitExclusionsAndLimitations,
} from "../../../helpers";

/**
 * BenefitData represents a benefit in plan_card.package_benefits
 */
export interface BenefitData {
  label: string;
  service: string;
}

/**
 * convert array of BenefitData[] into table-friendly data that
 * can be rendered by `<RenderedTable>`
 * @param plan - the plan
 * @param suppressed - indicates to suppress the benefit or not
 * @param t - translation function
 * @param category - the benefit category
 * @param benefits - array of BenefitData[]
 * @param sectionLabel - string passed to Tealium
 * @returns Record<string, unknown>[]
 */
export const convertBenefitData = ({
  plan,
  suppressed,
  t,
  category,
  benefits,
  sectionLabel,
}: {
  plan: Plan;
  suppressed: boolean;
  t: (id: string) => string;
  category: string;
  benefits: BenefitData[];
  sectionLabel?: string;
}): Record<string, unknown>[] => {
  return benefits.map((benefit: BenefitData) => {
    const benefitCost = getBenefitCost(t, {
      plan,
      benefit: category,
      service: benefit.service,
    });
    return {
      label: benefit.label,
      value: (
        <SuppressionHandler suppress={suppressed} redactions={plan.redactions}>
          {benefitCost}
        </SuppressionHandler>
      ),
      limitsApply: (
        <LimitsApplyAccordion
          descriptors={getBenefitExclusionsAndLimitations({
            plan,
            benefit: category,
            service: benefit.service,
          })}
          tealiumSectionName={`${sectionLabel}|${benefit.label}`}
          ga4SectionName={benefit.label}
        />
      ),
    };
  });
};
